import { useCallback, useState } from 'react';
import type { DrilldownMetricKey, DrilldownPart, DrilldownRequest } from '@/types/analyticsV2';
import type { DrilldownView } from './drilldown-panel';

/** The ticket lists a number can open: the rows behind it and the panel's title. */
export const TICKET_DRILLDOWNS = {
  tickets: { metric: 'aiTicketCoverage', part: 'total', title: 'Tickets' },
  aiHandled: { metric: 'aiTicketCoverage', part: 'count', title: 'Tickets handled by AI' },
  automated: { metric: 'aiAutomation', part: 'count', title: 'Automated tickets' },
  avgAiResponses: { metric: 'avgAiResponsesPerTicket', part: 'total', title: 'AI responses per ticket' },
} as const satisfies Record<string, { metric: DrilldownMetricKey; part: DrilldownPart; title: string }>;

export type TicketDrilldownKey = keyof typeof TICKET_DRILLDOWNS;

export const ticketDrilldownView = (
  key: TicketDrilldownKey,
  filters: DrilldownRequest['filters'] = {},
  scope: string[] = [],
): DrilldownView => {
  const { metric, part, title } = TICKET_DRILLDOWNS[key];
  return { request: { metric, part, filters }, title, scope };
};

/** Which ticket list is shown and whether the panel is open; `show` opens one. */
export const useTicketDrilldown = () => {
  const [view, setView] = useState<DrilldownView | null>(null);
  const [open, setOpen] = useState(false);
  const show = useCallback((next: DrilldownView) => {
    setView(next);
    setOpen(true);
  }, []);
  return { view, open, onOpenChange: setOpen, show };
};
